import React from "react";
import _ from "lodash";
import convert from "convert-units";
import { withTranslation } from "react-i18next";
import UnitInput from "../../../parts/inputs/unit-input";
import DateInput from "../../../parts/inputs/date-input";
import Modal from "../../../parts/modal";
import { RillContext } from "../../../rill/RillReact/share/base";

const {
  COMPETITIONS: { LEVELS, FEDERATIONS, CATEGORIES, TYPES },
} = require("../../../constants");

class View extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    const { locals } = this.props;
    const { editCompetition } = locals;
    this.state = { type: _.get(editCompetition, "type") };
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  handleTypeChange({ target: { value } }) {
    if (this.state.type !== value) this.setState({ type: value });
  }

  render() {
    const { t, locals } = this.props;
    const { activeUser, editCompetition, units, momentTZ, query } = locals;
    const total = query.total || _.get(editCompetition, "total", 0);
    const wilks = query.wilks || _.get(editCompetition, "wilks", "");
    const isBenchOnly = _.includes(this.state.type, "Bench Only");
    const isSaved = _.has(editCompetition, "_id");
    return (
      <form
        action={`/actions/competition/save/${_.get(
          editCompetition,
          "_id",
          ""
        )}`}
        className="Edit-Competition"
        method="POST"
        data-noreset
      >
        <Modal width="470px" toClear={["wilks", "total"]}>
          <input type="hidden" name="tense" value="past" />
          <input type="hidden" name="total" value={total} />
          <h2>{t("editPreviousCompetition.title")}</h2>
          <div className="Main">
            <div className="frame wide alt">
              <div className="columns">
                <div className="column" data-col="1/2">
                  <div className="label">{t("editPreviousCompetition.competitionDate")}</div>
                  <DateInput
                    required
                    name="date"
                    defaultValue={_.get(editCompetition, "date", "")}
                    onChange={this.handleDateChange}
                    max={momentTZ().startOf("day")}
                  />
                </div>

                <div className="3/4"></div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editPreviousCompetition.competitionName")}</div>
                  <input
                    className="text-input"
                    type="text"
                    name="name"
                    defaultValue={_.get(editCompetition, "name", "")}
                    required
                  />
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editPreviousCompetition.federation")}</div>
                  <select
                    required
                    name="federation"
                    className="select-input"
                    defaultValue={_.get(editCompetition, "federation", "")}
                  >
                    <option disabled hidden value="">
                      {t("editPreviousCompetition.federation")}
                    </option>
                    {_.map(FEDERATIONS, (federation) => {
                      return (
                        <option key={federation} value={federation}>
                          {federation}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editPreviousCompetition.levelOfCompetition")}</div>
                  <select
                    name="level"
                    className="select-input"
                    defaultValue={_.get(editCompetition, "level", "")}
                  >
                    <option disabled hidden value="">
                      {t("editPreviousCompetition.level")}
                    </option>
                    {_.map(LEVELS, (level) => {
                      return (
                        <option key={level} value={level}>
                          {_.capitalize(level)}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editPreviousCompetition.category")}</div>
                  <select
                    required
                    name="category"
                    className="select-input"
                    defaultValue={_.get(editCompetition, "category", "")}
                  >
                    <option disabled hidden value="">
                      {t("editPreviousCompetition.category")}
                    </option>
                    {_.map(CATEGORIES, (category) => {
                      return (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/1">
                  <div className="label">{t("editPreviousCompetition.competitionType")}</div>
                  <select
                    required
                    name="type"
                    onChange={this.handleTypeChange}
                    className="select-input"
                    defaultValue={_.get(editCompetition, "type", "")}
                  >
                    <option disabled hidden value="">
                      {t("editPreviousCompetition.type")}
                    </option>
                    {_.map(TYPES, (type) => {
                      return (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/2">
                  <div className="label">{t("editPreviousCompetition.weightClass")}</div>
                  <input
                    required
                    type="text"
                    className="text-input"
                    name="weightClass"
                    placeholder=""
                    defaultValue={_.get(editCompetition, "weightClass", "")}
                  />
                </div>

                <div className="column" data-col="1/2">
                  <div className="label">{t("editPreviousCompetition.bodyWeight")}</div>
                  <UnitInput
                    metric="kg"
                    imperial="lb"
                    className="text-input"
                    name="weight"
                    min="1"
                    placeholder=""
                    defaultValue={_.get(
                      editCompetition,
                      "weight",
                      _.get(activeUser, "weight", "")
                    )}
                  />
                </div>

                <div>
                  <div className="column" data-col="1/1">
                    <div className="label">{t("editPreviousCompetition.attempts")}</div>
                    <div className="note">
                      {t("editPreviousCompetition.attemptsNote")}
                    </div>
                  </div>

                  {!isBenchOnly && (
                    <div className="column" data-col="1/3">
                      <div className="label" style={{ color: "#8c479a" }}>
                        {t("editPreviousCompetition.squat")}
                      </div>
                      <UnitInput
                        metric="kg"
                        imperial="lb"
                        className="text-input"
                        name="attempts[squat][0]"
                        placeholder={t("editPreviousCompetition.attempt1")}
                        defaultValue={_.get(
                          editCompetition,
                          "attempts.squat[0]",
                          ""
                        )}
                      />
                      <UnitInput
                        metric="kg"
                        imperial="lb"
                        className="text-input"
                        name="attempts[squat][1]"
                        placeholder={t("editPreviousCompetition.attempt2")}
                        defaultValue={_.get(
                          editCompetition,
                          "attempts.squat[1]",
                          ""
                        )}
                      />
                      <UnitInput
                        metric="kg"
                        imperial="lb"
                        className="text-input"
                        name="attempts[squat][2]"
                        placeholder={t("editPreviousCompetition.attempt3")}
                        defaultValue={_.get(
                          editCompetition,
                          "attempts.squat[2]",
                          ""
                        )}
                      />
                    </div>
                  )}

                  <div className="column" data-col="1/3">
                    <div className="label" style={{ color: "#2482c5" }}>
                      {t("editPreviousCompetition.benchPress")}
                    </div>
                    <UnitInput
                      metric="kg"
                      imperial="lb"
                      className="text-input"
                      name="attempts[bench][0]"
                      placeholder={t("editPreviousCompetition.attempt1")}
                      defaultValue={_.get(
                        editCompetition,
                        "attempts.bench[0]",
                        ""
                      )}
                    />
                    <UnitInput
                      metric="kg"
                      imperial="lb"
                      className="text-input"
                      name="attempts[bench][1]"
                      placeholder={t("editPreviousCompetition.attempt2")}
                      defaultValue={_.get(
                        editCompetition,
                        "attempts.bench[1]",
                        ""
                      )}
                    />
                    <UnitInput
                      metric="kg"
                      imperial="lb"
                      className="text-input"
                      name="attempts[bench][2]"
                      placeholder={t("editPreviousCompetition.attempt3")}
                      defaultValue={_.get(
                        editCompetition,
                        "attempts.bench[2]",
                        ""
                      )}
                    />
                  </div>
                  {!isBenchOnly && (
                    <div className="column" data-col="1/3">
                      <div className="label" style={{ color: "var(--red)" }}>
                        {t("editPreviousCompetition.deadlift")}
                      </div>
                      <UnitInput
                        metric="kg"
                        imperial="lb"
                        className="text-input"
                        name="attempts[deadlift][0]"
                        placeholder={t("editPreviousCompetition.attempt1")}
                        defaultValue={_.get(
                          editCompetition,
                          "attempts.deadlift[0]",
                          ""
                        )}
                      />
                      <UnitInput
                        metric="kg"
                        imperial="lb"
                        className="text-input"
                        name="attempts[deadlift][1]"
                        placeholder={t("editPreviousCompetition.attempt2")}
                        defaultValue={_.get(
                          editCompetition,
                          "attempts.deadlift[1]",
                          ""
                        )}
                      />
                      <UnitInput
                        metric="kg"
                        imperial="lb"
                        className="text-input"
                        name="attempts[deadlift][2]"
                        placeholder={t("editPreviousCompetition.attempt3")}
                        defaultValue={_.get(
                          editCompetition,
                          "attempts.deadlift[2]",
                          ""
                        )}
                      />
                    </div>
                  )}

                  <div className="column" data-col="1/2">
                    <div className="label">{t("editPreviousCompetition.total")}</div>
                    {units === "metric" ? (
                      <div className="calculated-total">
                        <b>{_.round(total, 1)} kg</b>
                        <br />({_.round(
                          convert(total).from("kg").to("lb"),
                          1
                        )}{" "}
                        lbs)
                      </div>
                    ) : (
                      <div className="calculated-total">
                        <b>
                          {_.round(convert(total).from("kg").to("lb"), 1)} lbs
                        </b>
                        <br />({_.round(total, 1)} kg)
                      </div>
                    )}
                  </div>

                  <div className="column" data-col="1/2">
                    <div className="label">{t("editPreviousCompetition.wilks")}</div>
                    <input
                      key={wilks}
                      className="text-input"
                      type="text"
                      name="wilks"
                      placeholder={t("editPreviousCompetition.wilksPlaceholder")}
                      defaultValue={wilks}
                    />
                  </div>

                  <div className="column" data-col="1/2">
                    <button
                      type="submit"
                      className="button-input"
                      name="calculate"
                      value="true"
                    >
                      {t("editPreviousCompetition.calculateTotalWilks")}
                    </button>
                  </div>

                  <div className="column" data-col="1/2">
                    <div className="calculated-wilks-note">
                      {t("editPreviousCompetition.wilksOverrideNote")}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="actions">
              {isSaved ? (
                <a
                  className="button delete"
                  href={`/actions/competition/remove/${_.get(
                    editCompetition,
                    "_id"
                  )}`}
                >
                  {t("editPreviousCompetition.deleteCompetition")}
                </a>
              ) : (
                <a
                  href={`/actions/competition/cancel/?redirect=${encodeURIComponent(
                    "/dashboard/competitions/?list=previous"
                  )}`}
                  className="button alt"
                >
                  {t("common:cancel")}
                </a>
              )}
              <button className="button button-input" type="submit">
                {t("editPreviousCompetition.addResult")}
              </button>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

View.contextType = RillContext;

export default withTranslation("dashboard")(View);
